import { ComponentProps } from 'react';

import { CreditCardField } from './CreditCardField';
import { useDefaultGetAdditionalStripeData } from './useDefaultGetAdditionalStripeData';

export function CreditCardFieldWithDefaultAdditionalData(
  props: Omit<
    ComponentProps<typeof CreditCardField>,
    'getAdditionalStripeData'
  >,
) {
  const { getAdditionalStripeData } = useDefaultGetAdditionalStripeData();

  return (
    <CreditCardField
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      getAdditionalStripeData={getAdditionalStripeData}
    />
  );
}
